// extracted by mini-css-extract-plugin
module.exports = {"Hello":"Hello_Hello__dA6Oy","buttons":"Hello_buttons__2CAq7"};